export default __webpack_public_path__ + "locales/hy-AM/SocialAuthWelcomeDialog.json?hash=7affaae33d327a644d137bbdcc95e9f1";